import axios from 'axios';

import { headers, salesServiceUrl } from '../../config';

export function getSalesOrderPendingFullfillmentReport(params) {
    return axios.get(`${salesServiceUrl}/blanket-pending-fulfillment`, { headers: headers(), params });
}

export function getSalesByItemReport(params) {
    return axios.get(`${salesServiceUrl}/reports/sales-by-item`, { headers: headers(), params });
}

export function getInvoiceItemBreakdown(params) {
    return axios.get(`${salesServiceUrl}/reports/invoice-item-breakdown`, { headers: headers(), params });
}

export function getAgreementItemBreakdown(params) {
    return axios.get(`${salesServiceUrl}/reports/agreement-item-breakdown`, { headers: headers(), params });
}

export function getSalesBySalesOrderReport() {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve({
                data: [
                    {
                        item_code: "CRT00001",
                        item_name: "Concrete C25",
                        quantity: 300,
                        value: 3112,
                        average_price: 31312
                    },
                    {
                        item_code: "CRT00002",
                        item_name: "Concrete C30",
                        quantity: 250,
                        value: 223,
                        average_price: 3500
                    }
                ]
            })
        }, 300);
    });
}

export function getSalesOrderReport(params) {
    return axios.get(`${salesServiceUrl}/reports/sales-orders`, { headers: headers(), params });
}